import { render, staticRenderFns } from "./Contract.vue?vue&type=template&id=10fb879e&scoped=true&"
import script from "./Contract.vue?vue&type=script&lang=js&"
export * from "./Contract.vue?vue&type=script&lang=js&"
import style0 from "./Contract.vue?vue&type=style&index=0&id=10fb879e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fb879e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/advtool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10fb879e')) {
      api.createRecord('10fb879e', component.options)
    } else {
      api.reload('10fb879e', component.options)
    }
    module.hot.accept("./Contract.vue?vue&type=template&id=10fb879e&scoped=true&", function () {
      api.rerender('10fb879e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Contract.vue"
export default component.exports